import { createFileRoute, redirect } from "@tanstack/react-router";

// Sessions page retired — send admins to the dashboard.
export const Route = createFileRoute("/admin/meetings")({
  beforeLoad: () => {
    throw redirect({ to: "/admin" });
  },
});
